import AppsIcon from "@mui/icons-material/Apps";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SwapHorizontalCircleOutlinedIcon from "@mui/icons-material/SwapHorizontalCircleOutlined";
export const sidebarConfig = [
  {
    title: "Skill Mappings",
    path: "/skill-mappings",
    icon: AppsIcon,
  },
  {
    title: "Errors & Exceptions",
    path: "/errors-exceptions",
    icon: WarningAmberIcon,
  },
  {
    title: "Process Log",
    path: "/process-log",
    icon: AccessTimeIcon,
  },
  {
    title: "User Activity Log",
    path: "/user-activity-log",
    icon: SwapHorizontalCircleOutlinedIcon,
  },
];
